var map = {
	"./images/gov-block.jpg": 1868
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1867;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners ^.*\/gov\-block\.jpg$
// module id = 1867
// module chunks = 146